import { render, staticRenderFns } from "./WorkFlow.vue?vue&type=template&id=04ab36a0"
import script from "./WorkFlow.vue?vue&type=script&lang=js"
export * from "./WorkFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports